'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _flatten2 = require('lodash/flatten');

var _flatten3 = _interopRequireDefault(_flatten2);

var _uniq2 = require('lodash/uniq');

var _uniq3 = _interopRequireDefault(_uniq2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _constants = require('../../constants');

var _util = require('../../utils/util');

var _FormattingUtils = require('../../utils/FormattingUtils');

var _FormattingUtils2 = _interopRequireDefault(_FormattingUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var EMPTY_FIELD = _constants.AppConstants.EMPTY_FIELD,
    NO_CHANGE_FIELD = _constants.AppConstants.NO_CHANGE_FIELD,
    REPRESENTATIVE_ASSIGNMENTS = _constants.AppConstants.REPRESENTATIVE_ASSIGNMENTS;
var getNameOrDefault = _FormattingUtils2.default.getNameOrDefault;
var RepresentativeDropdownAssign = (_dec = (0, _mobxReact.inject)('FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(RepresentativeDropdownAssign, _Component);

  function RepresentativeDropdownAssign() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RepresentativeDropdownAssign);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RepresentativeDropdownAssign.__proto__ || Object.getPrototypeOf(RepresentativeDropdownAssign)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isLoading', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RepresentativeDropdownAssign, [{
    key: 'onSelect',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventKey) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isLoading = true;
                _context.next = 3;
                return this.props.onChange(eventKey);

              case 3:
                this.isLoading = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSelect(_x) {
        return _ref2.apply(this, arguments);
      }

      return onSelect;
    }()
  }, {
    key: 'buildMenuItems',
    value: function buildMenuItems() {
      var _props = this.props,
          isBulkUpdate = _props.isBulkUpdate,
          omit = _props.omit,
          selected = _props.selected,
          omitIds = Array.isArray(omit) ? omit : [omit],
          representatives = (0, _filter3.default)(this.representatives, function (rep) {
        return !omitIds.includes(rep.id);
      }),
          groups = (0, _uniq3.default)((0, _flatten3.default)(representatives.map(function (r) {
        return (0, _mobx.toJS)(r.groups);
      }))),
          menuItems = [],
          sortedGroups = (0, _util.sortArrayByArray)(groups, REPRESENTATIVE_ASSIGNMENTS);

      // No change option, used for bulk updates

      if (isBulkUpdate) {
        menuItems.push({
          eventKey: NO_CHANGE_FIELD,
          key: NO_CHANGE_FIELD,
          label: NO_CHANGE_FIELD
        });
      }

      // Unassign option, disabled if no selection
      menuItems.push({
        // Unassign is always enabled in a bulk update
        disabled: isBulkUpdate ? false : !selected,
        eventKey: null,
        key: null,
        label: 'Unassign'
      });

      sortedGroups.forEach(function (group) {
        // Group header
        menuItems.push({
          header: true,
          key: 'header_' + group,
          label: group
        });

        // Every rep in this group
        representatives.filter(function (r) {
          return r.groups.includes(group);
        }).forEach(function (representative) {
          menuItems.push({
            active: representative.id === selected,
            eventKey: representative.id,
            key: group + '_' + representative.id,
            label: getNameOrDefault(representative)
          });
        });
      });

      // Representatives with no assigned groups
      var unassigned = representatives.filter(function (r) {
        return r.groups.length === 0;
      });
      if (unassigned.length > 0) {
        menuItems.push({
          header: true,
          key: 'header_norole',
          label: 'No role'
        });
        unassigned.forEach(function (representative) {
          menuItems.push({
            active: representative.id === selected,
            eventKey: representative.id,
            key: 'norole_' + representative.id,
            label: getNameOrDefault(representative)
          });
        });
      }

      return menuItems;
    }
  }, {
    key: 'getMenuItemLabel',
    value: function getMenuItemLabel() {
      var _props2 = this.props,
          isBulkUpdate = _props2.isBulkUpdate,
          selected = _props2.selected,
          hasSelectedRepresentative = !!selected;


      if (!isBulkUpdate) {
        return hasSelectedRepresentative ? getNameOrDefault((0, _find3.default)(this.representatives, { id: selected })) : EMPTY_FIELD;
      }

      if (selected === null) {
        return 'Unassign';
      } else if (selected === NO_CHANGE_FIELD) {
        return NO_CHANGE_FIELD;
      }

      return getNameOrDefault((0, _find3.default)(this.representatives, { id: selected }));
    }
  }, {
    key: 'getEmptyMenuItemLabel',
    value: function getEmptyMenuItemLabel(isBulkUpdate, selected) {
      if (isBulkUpdate) {
        return 'Unassign';
      }
      return EMPTY_FIELD;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var label = this.getMenuItemLabel(),
          title = this.isLoading ? 'Loading...' : label;

      return _react2.default.createElement(
        'div',
        { className: 'dropdown-arrow right' },
        _react2.default.createElement(
          _DropdownButton2.default,
          {
            bsStyle: 'link',
            disabled: this.isLoading,
            id: 'dropdown-representative',
            pullRight: true,
            title: title
          },
          this.buildMenuItems().map(function (attr) {
            return _react2.default.createElement(
              _MenuItem2.default,
              _extends({
                key: attr.key,
                onSelect: _this2.onSelect
              }, attr),
              attr.label
            );
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'representatives',


    // The funder's staff, unless the caller has a narrower list to offer -- the lending pages offer
    // only staff who can see a loan account.
    get: function get() {
      var _props3 = this.props,
          FunderStore = _props3.FunderStore,
          representatives = _props3.representatives;


      return representatives || FunderStore.representatives;
    }
  }]);

  return RepresentativeDropdownAssign;
}(_react.Component), _class3.defaultProps = {
  isBulkUpdate: false,
  omit: null,
  onChange: _omit3.default,
  representatives: null,
  selected: null
}, _class3.propTypes = {
  FunderStore: _propTypes2.default.object.isRequired,
  isBulkUpdate: _propTypes2.default.bool,
  omit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  onChange: _propTypes2.default.func,
  representatives: _propTypes2.default.array,
  selected: _propTypes2.default.string
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = RepresentativeDropdownAssign;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(EMPTY_FIELD, 'EMPTY_FIELD', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(NO_CHANGE_FIELD, 'NO_CHANGE_FIELD', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(REPRESENTATIVE_ASSIGNMENTS, 'REPRESENTATIVE_ASSIGNMENTS', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(RepresentativeDropdownAssign, 'RepresentativeDropdownAssign', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/RepresentativeDropdownAssign.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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